import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_SECRET_KEY; // Ensure your key is stored securely

export const encryptId = (id) => {
  try {
    const idString = String(id);
    const encryptedId = CryptoJS.AES.encrypt(idString, secretKey).toString();
    
    return btoa(encryptedId); // Encode to Base64
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};

export const decryptId = (encryptedId) => {
  try {
    const decoded = atob(encryptedId); // Decode from Base64
    const decryptedBytes = CryptoJS.AES.decrypt(decoded, secretKey);
    
    return decryptedBytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};
